import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translate = inject(TranslateService);

  currentLang = signal<string>('it');

  constructor() {
    this.init();
  }

  private init() {
    this.translate.addLangs(['it', 'en']);
    this.translate.setDefaultLang('it');

    // Try to get lang from browser or storage
    const browserLang = this.translate.getBrowserLang();
    const storageLang = localStorage.getItem('lang');

    const langToUse = storageLang || (browserLang && browserLang.match(/it|en/) ? browserLang : 'it');
    this.useLanguage(langToUse);
  }

  useLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLang.set(lang);
    localStorage.setItem('lang', lang);
  }
}
